// import Footer from './Footer';
// import UserMarket from '../UserMarket';
import { isRoundedPlatform } from '@/helpers/environmentHelper';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import { useScreenSizes } from '@/utils/providers/ScreenSizesProvider';
import cn from 'classnames';
import { useMemo, useState } from 'react';
import Navbar from '../Navbar';
import UniversalSidebar from '../UniversalSidebar';

interface LiteLayoutProps extends React.PropsWithChildren {}

export default function LiteLayout({ children }: LiteLayoutProps) {
    const settings = useDisclosure(false);
    const { mobile, tablet } = useScreenSizes();

    const [isExpanded, setIsExpanded] = useState(true);

    const isMobile = useMemo(() => mobile || tablet, [mobile, tablet]);

    const width = useMemo(() => {
        if (isMobile) {
            return '100%';
        } else {
            return isExpanded ? 'calc(100% - 257px)' : 'calc(100% - 61px)';
        }
    }, [isExpanded, isMobile]);

    const marginLeft = useMemo(() => {
        if (isMobile) {
            return 0;
        } else {
            return isExpanded ? 257 : 61;
        }
    }, [isExpanded, isMobile]);

    return (
        <div className="relative flex flex-col border-t-[1.5px] lg:border-t-[3px] border-brand-border">
            <UniversalSidebar
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                settingsDisclosure={settings}
                isAlwaysExpanded
            />
            <div
                className={cn('flex flex-col h-screen', {
                    'transition-all duration-200': !isMobile
                })}
                style={{ width, marginLeft }}>
                <Navbar settings={settings} />
                <main
                    className={cn(
                        'h-full overflow-y-auto border-[1.5px] lg:border-[3px] border-t-0 border-brand-border',
                        {
                            'bg-brand-background': !isRoundedPlatform
                        }
                    )}>
                    {children}
                </main>
            </div>
        </div>
    );
}
